/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
// !!!!! Deprecated !!!!!

function paddingDate(val) {
  return ('0' + val).slice(-2)
}

function dateToString(date) {
  if (!date) return
  return date.getFullYear() + '/' + paddingDate(date.getMonth() + 1) + '/' + paddingDate(date.getDate()) + ' ' + paddingDate(date.getHours()) + ':' + paddingDate(date.getMinutes())
}

function dateToStringDate(date) {
  if (!date) return
  return date.getFullYear() + '/' + paddingDate(date.getMonth() + 1) + '/' + paddingDate(date.getDate()) + ' (' + ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()] + ')'
}

function dateToStringDateWithoutYear(date) {
  if (!date) return
  return date.getMonth() + 1 + '/' + paddingDate(date.getDate()) + ' (' + ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()] + ')'
}

function dateToInput(date) {
  if (!date) return

  const year = date.getFullYear()
  const month = paddingDate(date.getMonth() + 1)
  const day = paddingDate(date.getDate())

  return `${year}-${month}-${day}`
}

function dateToStringDateMonth(date) {
  if (!date) return
  return date.getFullYear() + '/' + paddingDate(date.getMonth() + 1)
}

//This function will receive safe dateStr cause isValidDateStr
//return null if invalid dateStr
function stringToDate(dateStr) {
  let date = new Date()
  const [dStr, tStr] = dateStr.split(' ')
  const [year, month, day] = dStr.split('/').map(Number)
  const [hour, minute] = tStr.split(':').map(Number)

  if (!isValidDate(year, month, day, hour, minute)) {
    return null
  }

  date.setFullYear(Number(year))
  date.setMonth(Number(month - 1))
  date.setDate(Number(day))
  date.setHours(Number(hour))
  date.setMinutes(Number(minute))

  return date
}

function isValidDateStr(dateStr) {
  const [date, time] = dateStr.split(' ')
  if (!(date && time)) return false
  const [year, month, day] = date.split('/')
  const [hour, minute] = time.split(':')
  return [year, month, day, hour, minute].every((e, i, a) => {
    return !isNaN(e)
  })
}

function paramToDate(dateParam) {
  let date = new Date()
  const [year, month, day] = dateParam.split('-').map(Number)
  if (!isValidDate(year, month, day)) {
    return null
  }
  date.setFullYear(year)
  date.setMonth(month - 1, day)
  date.setHours(0)
  date.setMinutes(0)
  date.setSeconds(0)

  return date
}

function dateToParam(date) {
  return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
}

function isValidDate(year, month, day, hour = 0, minute = 0) {
  const validations = [
    { min: 1970, max: 2099 }, // start from UNIX time.
    { min: 1, max: 12 },
    { min: 1, max: 31 },
    { min: 0, max: 23 },
    { min: 0, max: 59 }
  ]
  const isValid = [year, month, day, hour, minute].every((e, i, a) => {
    return validations[i]['min'] <= e && e <= validations[i]['max']
  })
  return isValid
}

export { isValidDateStr, stringToDate, dateToString, dateToStringDate, dateToStringDateWithoutYear, dateToStringDateMonth, paramToDate, dateToParam, dateToInput }
